import {
  ImageScaleView,
  LinearAddFilter,
  View,
} from '@play-co/timestep-core/ui';
import TilingBackground from './TilingBackground';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import SparkleFx from './SparkleFx';

export default class TeamIntroHero extends View {
  private readonly contentView: View;
  private shine!: ImageScaleView;

  constructor(opts: { superview: View; x?: number; y?: number }) {
    super({ ...opts, centerOnOrigin: true });
    this.addFrame();
    this.contentView = new View({ superview: this, y: -3 });
    this.addBackground();
    this.addSpeeches();
    this.addOverlay();
    this.addDecorations();
  }

  private addFrame() {
    new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/team/team_intro_hero_frame.png',
      width: 518,
      height: 614,
      centerOnOrigin: true,
    });
  }

  private addBackground() {
    new TilingBackground({
      maskOpts: {
        superview: this.contentView,
        mask: 'assets/ui/match2/team/team_intro_hero_mask.png',
        width: 510,
        height: 600,
        centerOnOrigin: true,
      },
      tileOpts: {
        image: 'assets/ui/match2/team/team_tile_bg.png',
        columns: 3,
      },
      movementOpts: {
        direction: 'diagonal',
      },
    });
  }

  private addSpeeches() {
    const bubbles = new ImageScaleView({
      superview: this.contentView,
      image: 'assets/ui/match2/team/team_intro_hero_bubbles.png',
      width: 510,
      height: 600,
      centerOnOrigin: true,
    });

    new LangBitmapFontTextView({
      superview: bubbles,
      size: 27,
      color: '#FFFFFF',
      font: 'Title',
      localeText: () => i18n('match2.team.intro_message2'),
      width: 295,
      height: 110,
      verticalAlign: 'center',
      centerOnOrigin: true,
      x: 330,
      y: 98,
    });

    new LangBitmapFontTextView({
      superview: bubbles,
      size: 30,
      color: '#FFFFFF',
      font: 'Title',
      localeText: () => i18n('match2.team.intro_message3'),
      width: 280,
      height: 90,
      verticalAlign: 'center',
      centerOnOrigin: true,
      x: 210,
      y: 296,
    });

    new LangBitmapFontTextView({
      superview: bubbles,
      size: 27,
      color: '#FFFFFF',
      font: 'Title',
      localeText: () => i18n('match2.team.intro_message4'),
      width: 295,
      height: 105,
      verticalAlign: 'center',
      centerOnOrigin: true,
      x: 330,
      y: 481,
    });
  }

  private addOverlay() {
    new ImageScaleView({
      superview: this.contentView,
      image: 'assets/ui/match2/team/team_intro_hero_overlay.png',
      width: 510,
      height: 600,
      centerOnOrigin: true,
      filter: new LinearAddFilter('#FFFFFF'),
      opacity: 0.2,
    });

    this.shine = new ImageScaleView({
      superview: this.contentView,
      image: 'assets/ui/match2/common/fx_shine.png',
      width: 187,
      height: 153,
      x: -150,
      y: 163,
      centerOnOrigin: true,
      centerAnchor: true,
      filter: new LinearAddFilter('#FFFFFF'),
      opacity: 0.15,
    });
  }

  private addDecorations() {
    new ImageScaleView({
      superview: this.contentView,
      image: 'assets/ui/match2/team/team_intro_hero_mascots.png',
      width: 510,
      height: 600,
      centerOnOrigin: true,
    });

    const amount = 6;
    const scale = 1.5;

    new SparkleFx({
      superview: this.contentView,
      width: 120,
      height: 110,
      x: -152,
      y: -230,
      amount,
      scale,
    });

    new SparkleFx({
      superview: this.contentView,
      width: 120,
      height: 110,
      x: 115,
      y: -65,
      amount,
      scale,
    });

    new SparkleFx({
      superview: this.contentView,
      width: 95,
      height: 110,
      x: -150,
      y: 175,
      amount,
      scale,
    });
  }

  public tick(dt: number) {
    if (!this.shine) return;
    this.shine.style.r = (this.shine.style.r + dt * 0.00075) % (Math.PI * 2);
  }
}
